import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { SecurityAppSecurityEventsHistogram } from "@graylog/enterprise-api";
import { categoryKey } from "security-app/components/SecurityEvents/Alerts/Constants";
import ExportResultsButton from "security-app/components/SecurityEvents/Alerts/ExportResultsButton";
import MetricsAction from "security-app/components/SecurityEvents/Alerts/MetricsAction";
import { useIsInteractiveMode } from "views/components/contexts/InteractiveContext";
import Spinner from "components/common/Spinner";
import EventsTacticsHistogram from "./EventsTacticsHistogram";
import EventsTechniquesHistogram from "./EventsTechniquesHistogram";
const ChartContainer = styled.div`
  padding-top: 20px;
`;
const EventsCategoriesHistogram = ({ searchParams, setFilters }) => {
  var _a;
  const { t } = useTranslation("enterprise_security_events");
  const interactive = useIsInteractiveMode();
  const tactic = (_a = searchParams.filters) == null ? void 0 : _a.get(categoryKey, []).find((filter) => filter.toLocaleLowerCase().startsWith("ta"));
  const histogram = tactic ? /* @__PURE__ */ React.createElement(EventsTechniquesHistogram, { searchParams, setFilters }) : /* @__PURE__ */ React.createElement(EventsTacticsHistogram, { searchParams, setFilters });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MetricsAction, null, interactive ? /* @__PURE__ */ React.createElement(
    ExportResultsButton,
    {
      type: tactic ? "techniques" : "tactics",
      title: tactic ? t("categories_histogram.techniques") : t("categories_histogram.tactics"),
      searchParams
    }
  ) : null), /* @__PURE__ */ React.createElement(ChartContainer, null, histogram));
};
const StyledCenter = styled.div`
  padding-left: 100px;
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
`;
const MissingPrerequisites = () => {
  const { t } = useTranslation("enterprise_security_events");
  return /* @__PURE__ */ React.createElement(StyledCenter, null, /* @__PURE__ */ React.createElement("h2", null, t("missing_prerequisites.title")), /* @__PURE__ */ React.createElement("p", null, t("missing_prerequisites.description")), /* @__PURE__ */ React.createElement("p", null, t("missing_prerequisites.install_hint")));
};
const SafeEventsCategoriesHistogram = ({ searchParams, setFilters }) => {
  const { data: status, isInitialLoading } = useQuery({
    queryKey: ["events", "histograms", "status"],
    queryFn: () => SecurityAppSecurityEventsHistogram.status()
  });
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return (status == null ? void 0 : status.usable) ? /* @__PURE__ */ React.createElement(EventsCategoriesHistogram, { searchParams, setFilters }) : /* @__PURE__ */ React.createElement(MissingPrerequisites, null);
};
export default SafeEventsCategoriesHistogram;
